/** @format */

import React from "react";

type footerLinksProps = {
  children: JSX.Element[];
};

const FooterLinks = ({ children }: footerLinksProps) => {
  return (
    <div className="footer-links flex flex-col space-y-[22px] font-normal text-white text-[14px] leading-[19.1px] mt-[22px]">
      {children}
    </div>
  );
};

export default FooterLinks;
